import { render, staticRenderFns } from "./TabWrapper.vue?vue&type=template&id=15db5e08&scoped=true"
import script from "./TabWrapper.vue?vue&type=script&lang=js"
export * from "./TabWrapper.vue?vue&type=script&lang=js"
import style0 from "./TabWrapper.vue?vue&type=style&index=0&id=15db5e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db5e08",
  null
  
)

export default component.exports